module.exports = __webpack_public_path__ + "static/masonic-apron-84251b21bf6fb0413b55c3f7d0f5711a.jpg";